import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { cartLinkStyles } from "@WhiteCap/Overrides/Widgets/Common/CartLink";
import { css } from "styled-components";

// EC-94 : B2B Website Header
// Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments.
cartLinkStyles.routerLink = {
    typographyProps: {
        variant: "headerSecondary",
        css: css`
            font-family: inherit !important;
            font-weight: 500 !important;
        `,
    },
    icon: {
        iconProps: {
            size: 24,
            css: css`
                margin-right: 10px;
            `,
        },
    },
    color: "secondary.contrast",
    css: css`
        margin-left: 16px;
        height: 50px;
        padding: 0 4px 0 0px;
        position: relative;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    
                    null,
                    null,
                    null,
                    css`
                        margin-left: 0;
                    `,
                    css`
                       margin-left: 0;
                    `,
                    
                ],
                "max",
            );
        }}
    `,
};
// End: Refactored dynamic CSS from CMS to code for consistent behavior across environments.